import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { ExtensionType, extensions } from '@pixi/extensions';
var TransformFeedbackSystem = /*#__PURE__*/function () {
  function TransformFeedbackSystem(renderer) {
    _classCallCheck(this, TransformFeedbackSystem);
    this.renderer = renderer;
  }
  _createClass(TransformFeedbackSystem, [{
    key: "contextChange",
    value: function contextChange() {
      this.gl = this.renderer.gl;
      this.CONTEXT_UID = this.renderer.CONTEXT_UID;
    }
  }, {
    key: "bind",
    value: function bind(transformFeedback) {
      var gl = this.gl,
        CONTEXT_UID = this.CONTEXT_UID;
      var glTransformFeedback = transformFeedback._glTransformFeedbacks[CONTEXT_UID] || this.createGLTransformFeedback(transformFeedback);
      gl.bindTransformFeedback(gl.TRANSFORM_FEEDBACK, glTransformFeedback);
    }
  }, {
    key: "unbind",
    value: function unbind() {
      var gl = this.gl;
      gl.bindTransformFeedback(gl.TRANSFORM_FEEDBACK, null);
    }
  }, {
    key: "beginTransformFeedback",
    value: function beginTransformFeedback(drawMode, shader) {
      var gl = this.gl,
        renderer = this.renderer;
      if (shader) {
        renderer.shader.bind(shader);
      }
      gl.beginTransformFeedback(drawMode);
    }
  }, {
    key: "endTransformFeedback",
    value: function endTransformFeedback() {
      var gl = this.gl;
      gl.endTransformFeedback();
    }
  }, {
    key: "createGLTransformFeedback",
    value: function createGLTransformFeedback(tf) {
      var gl = this.gl,
        renderer = this.renderer,
        CONTEXT_UID = this.CONTEXT_UID;
      var glTransformFeedback = gl.createTransformFeedback();
      tf._glTransformFeedbacks[CONTEXT_UID] = glTransformFeedback;
      gl.bindTransformFeedback(gl.TRANSFORM_FEEDBACK, glTransformFeedback);
      for (var i = 0; i < tf.buffers.length; i++) {
        var buffer = tf.buffers[i];
        if (!buffer) continue;
        renderer.buffer.update(buffer);
        buffer._glBuffers[CONTEXT_UID].refCount++;
        gl.bindBufferBase(gl.TRANSFORM_FEEDBACK_BUFFER, i, buffer._glBuffers[CONTEXT_UID].buffer || null);
      }
      gl.bindTransformFeedback(gl.TRANSFORM_FEEDBACK, null);
      tf.disposeRunner.add(this);
      return glTransformFeedback;
    }
  }, {
    key: "disposeTransformFeedback",
    value: function disposeTransformFeedback(tf, contextLost) {
      var glTF = tf._glTransformFeedbacks[this.CONTEXT_UID];
      var gl = this.gl;
      tf.disposeRunner.remove(this);
      var bufferSystem = this.renderer.buffer;
      if (bufferSystem) {
        for (var i = 0; i < tf.buffers.length; i++) {
          var buffer = tf.buffers[i];
          if (!buffer) continue;
          var buf = buffer._glBuffers[this.CONTEXT_UID];
          if (buf) {
            buf.refCount--;
            if (buf.refCount === 0 && !contextLost) {
              bufferSystem.dispose(buffer, contextLost);
            }
          }
        }
      }
      if (!glTF) {
        return;
      }
      if (!contextLost) {
        gl.deleteTransformFeedback(glTF);
      }
      delete tf._glTransformFeedbacks[this.CONTEXT_UID];
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.renderer = null;
    }
  }]);
  return TransformFeedbackSystem;
}();
TransformFeedbackSystem.extension = {
  type: ExtensionType.RendererSystem,
  name: "transformFeedback"
};
extensions.add(TransformFeedbackSystem);
export { TransformFeedbackSystem };